import { atom } from 'jotai';

export const swingThreadToggleAtom = atom(false);

export const swingThreadOpenAtom = atom<Record<number, boolean>>({});
